import { IWizardStep } from "../../../../wizard/types";
import Content from "./Content";
import validator from "../validators/clone/validator";

export const cloneContentConfig: IWizardStep = {
  width: "568px",
  titleConfig: {
    titleText: "Clone program",
  },
  content: Content,
  validator: validator,
};
